module.exports = __webpack_public_path__ + "img/inputbtn2.5c6e53aa.svg";